import { useMutation } from 'react-query'
import putTermsConditions from '../services/putTermsConditions'

function usePutTermsConditions() {

  return useMutation((value:number)=>putTermsConditions(value) );
}

export default usePutTermsConditions
